import { render, staticRenderFns } from "./SendPintuan.vue?vue&type=template&id=33c0b79d&scoped=true"
import script from "./SendPintuan.vue?vue&type=script&lang=js"
export * from "./SendPintuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0b79d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c0b79d')) {
      api.createRecord('33c0b79d', component.options)
    } else {
      api.reload('33c0b79d', component.options)
    }
    module.hot.accept("./SendPintuan.vue?vue&type=template&id=33c0b79d&scoped=true", function () {
      api.rerender('33c0b79d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/pintuanSpu/SendPintuan.vue"
export default component.exports